export { default as deepMapObject } from './deepMapObject.js';
export { default as restrictScrollPrecision } from './restrictScrollPrecision.js';
export const isClient = typeof window !== 'undefined';